import WaitRebook from '@/views/WaitRebook/index.vue'

const WaitRebookRouter = {
  path: '/wait-rebook',
  name: 'WaitRebook',
  component: WaitRebook,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default WaitRebookRouter
